import { createFileRoute, Outlet } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/app/admin-settings/automatic-background-jobs/logs"
)({
  component: Outlet,
  beforeLoad(ctx) {
    return {
      getTitle: () => "Logs",
    }
  },
})
